import { useState, useEffect } from 'react';
import { Grid, TextField, Button, Box, FormControl, MenuItem, InputLabel, Select } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../../service/apiService';

const AddFpc = () => {
  const [years, setYears] = useState([]);
  const [formValues, setFormValues] = useState({
    fpoName: '',
    dateOfIncorporation: '',
    registrationNumber: '',
    address: '',
    totalShareCapital: 0,
    shareHolders: 0,
    business: '',
    financialPerformance: '',
    noOfMale: 0,
    noOfFemale: 0,
    year: '',          
    turnover: 0       
  });

  const fetchYears = async () => {
      try {
        const response = await apiService.get("/years/get-all");
        const fetchedYears = response.data;
        setYears(fetchedYears);
  
      } catch (error) { console.error("Error fetching years:", error); }
    };

  const navigate = useNavigate();
  const [dists, setAllDists] = useState([]);
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);    
  const isDistCoordinator = loginData?.districtCoordinatorsId !== null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    
  };
  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };
  useEffect(() => {
    fetchAllDist();
    fetchYears();
  }, []);
  


  const handleSubmit = async () => {
    const isConfirmed = window.confirm("Are you sure you want to add this FPC ?");
    
    if (!isConfirmed) {
        return; // If user cancels, exit the function without submitting
    }
    try {
      const payload = {
        ...formValues,
        districtId: Number(dist), 
        totalShareCapital: Number(formValues.totalShareCapital), 
        shareHolders: Number(formValues.shareHolders), 
        noOfMale: Number(formValues.noOfMale), 
        noOfFemale: Number(formValues.noOfFemale),
        turnover: Number(formValues.turnover), // ✅ added
        year: formValues.year 
    };
      const response = await apiService.post('/fpo/create', payload);
      if (response.data.status === false) {
        // alert(`Error: ${response.data.message}`);
        alert('An Error Occur During Addition of FPC');
        return;
    }
    if (response.data.status === true) {
      // alert(`Error: ${response.data.message}`);
      alert('FPC Added Successfully');
      navigate(-1);
  }

      console.log('Form submitted successfully:', response.data);
       // Navigate back to the previous page
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };

  const handleClose = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleTurnoverChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setFormValues({ ...formValues, turnover: value });
    }
  };


  return (
    <Box p={3}>
      <h2>Add FPC</h2>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="dense">
            <InputLabel id="dist-label">Year</InputLabel>
            <Select
              labelId="dist-label"
              label="Year"
              name="year"
              value={formValues.year}
              onChange={handleChange}
            >
              <MenuItem value="" disabled>Select Year</MenuItem>
              {years.map((y) => (
                <MenuItem key={y.yearId} value={y.yearValue}>
                  {y.yearValue}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth margin="dense">
          <InputLabel id="dist-label">Dist</InputLabel>
          <Select
            labelId="dist-label"
            label="Dist"
            name="districtId"
            value={dist}
            onChange={(e) => {
              setDist(e.target.value);
              // setFormData((prev) => ({ ...prev, districtId: e.target.value }));
            }}
            disabled={isDistCoordinator} 
            variant="outlined"
          >
            <MenuItem value={0} disabled>Select District</MenuItem> 
            {dists.map((d) => (
              <MenuItem key={d.districtId} value={d.districtId}>
                {d.districtName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="FPC Name"
            name="fpoName"
            value={formValues.fpoName}
            onChange={handleChange}
            margin='dense'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label="Date of Incorporation"
            name="dateOfIncorporation"
            value={formValues.dateOfIncorporation}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Registration Number"
            name="registrationNumber"
            value={formValues.registrationNumber}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Address"
            name="address"
            value={formValues.address}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Total Share Capital"
            name="totalShareCapital"
            value={formValues.totalShareCapital}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Turnover"
            name="turnover"
            value={formValues.turnover}
            onChange={handleTurnoverChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Share Holders"
            name="shareHolders"
            value={formValues.shareHolders}
            onChange={handleChange}
          />
        </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Male Members"
                name="noOfMale"
                value={formValues.noOfMale}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Female Members"
                name="noOfFemale"
                value={formValues.noOfFemale}
                onChange={handleChange}
              />
            </Grid>
        <Grid item xs={12} sm={6}>  
          <TextField
            fullWidth
            label="Business Name"
            name="business"
            value={formValues.business}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddFpc;
